import { analyticsSession } from '../common/utils/Analytics'
import { AnalyticsPageviewObjectType } from '../core/types/Analytics'

import { ANALYTICS_EVENTS, ANALYTICS_PAGEVIEWS } from './constants/Analytics'
import type { AnalyticsEventsObjectType } from './constants/Analytics'

export type AnalyticSession = Awaited<ReturnType<typeof analyticsSession>>

export const onAnalyticEvent = async (event: string, session: AnalyticSession) => {
  if (!session || !ANALYTICS_EVENTS[event]) return null

  return session
    .sendAnalyticEvent(ANALYTICS_EVENTS[event] as AnalyticsEventsObjectType)
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}

export const onAnalyticPageView = async (page: string, session: AnalyticSession) => {
  if (!session || !ANALYTICS_PAGEVIEWS[page]) {
    return null
  }

  return session
    .sendAnalyticsPageview(ANALYTICS_PAGEVIEWS[page] as AnalyticsPageviewObjectType)
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}
